import React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,} from '@mui/material';

export const ConfirmDialog = ({open, handleClose, handleConfirm}) => {
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Confirm action</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Are you sure?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}  variant={"outlined"}>
                    No
                </Button>
                <Button onClick={handleConfirm} color="warning" variant={"contained"} autoFocus>
                    Yes
                </Button>
            </DialogActions>
        </Dialog>
    );
};
